module.exports = __webpack_public_path__ + "img/img-avatar.a5e81f19.png";